// THE ADD-ONS' CUSTOMER-FACING LABELS. Nothing else: not which add-ons exist,
// not which are shown, not what order they are in, not which heading they sit
// under. All of that is the database's answer now, resolved and ordered by
// app/services/customer_catalogue.rb and published on /api/v2/services as
// `section`, `page_rank` and `on_prices_page`.
//
// WHAT THIS FILE USED TO BE, AND WHY IT IS NOT THAT ANY MORE. It held the
// whole list: 21 entries, each naming a service by its exact database name,
// grouped and ordered by hand. The names were lookup keys, and the contract
// written at the top of the file was "every name below resolves". On
// 4 October 2026 nine services were retired in the database. The names here
// stopped resolving, lib/use-live-price.js found no price for them (it has no
// baked fallback, by design) and they rendered as rows with a permanent blank
// where the price should be, in front of every visitor, until somebody edited
// this directory. A list in the bundle and a list in the database are two
// lists, and two lists disagree.
//
// The failure mode is now the other way round. A service retired in the
// database leaves this page by itself. A service added to the catalogue
// appears by itself, in the default section, at the foot of it, reading its
// database name and its database price. Neither needs a line of this file.
//
// SO WHY IS THERE STILL A FILE. Because the database names are not copy. They
// were typed over nine years by different people and they carry the scars:
// "Deep Clean 2 Child Car Seats" beside "Deep clean 2 seats" beside "Tree Sap
// Removal". Sentence case, and the word "and" instead of "&", are a display
// concern, and fixing them in the services table would rewrite the line items
// on nine years of orders. So the hand-written label survives here, and the
// database name is the fallback.
//
// KEYED BY CATALOGUE KEY, NOT BY NAME. The key (`screen_wash_refill`) is the
// stable identity; the name is the thing somebody may tidy up one afternoon.
// Keying on the name is what made a rename or a retirement able to blank a row
// on this page, so nothing here is keyed on a name again.
//
// A KEY WITH NO LABEL IS NOT A BUG. It reads its database name, which is
// correct English in every case and merely less tidy than a hand-written
// version. That is the whole safety property: a service we forgot to write a
// label for is still sold, still priced, and still legible.
//
// spec/design/derived_values_spec.rb checks that every key below is a key the
// catalogue actually publishes, so a label left behind by a retirement is
// caught by the suite rather than by a customer.
export const LABELS = {
  // Outside the car.
  bird_droppings_removal: 'Bird droppings removal',
  tyre_safety_check: 'Tyre safety check',
  screen_wash_refill: 'Screenwash refill, oil and fluid check',
  wax: 'Basic body wax',
  tree_sap_removal: 'Tree sap removal',
  hd_wax: 'HD Carnauba wax coating',
  alloy_wheels_sealant: 'Alloy wheel sealant, four wheels',
  soft_top_deep_clean: 'Soft roof deep clean and reproofing',
  clay_bar_machine_polish: 'Clay bar and machine polish',
  boot_bonnet_guitters_cleaned: 'Boot and bonnet gutters cleaned',
  // The four that read their database name until 6 Oct 2026; the wording is
  // the wash-pages content's (seo/wash_pages.json `addons`).
  windscreen_exterior_deep_clean: 'Windscreen deep clean and glass sealant',
  alloy_wheel_and_tyre_deep_clean: 'Alloy wheel and tyre deep clean',
  engine_bay_cleaned: 'Engine bay cleaned',

  // Inside the car.
  high_pressure_interior_steam_cleaned: 'High-pressure interior steam clean',
  odour_removal: 'Odour removal',
  deep_clean_two_child_seats: 'Deep clean, two child car seats',
  deep_clean_two_seats: 'Deep clean, two seats',
  deep_clean_child_pushchair: 'Single push chair deep clean',
  deep_clean_double_child_pushchair: 'Double push chair deep clean',
  interior_windows_cleaned: 'Interior windows cleaned',
  pet_hair_removal: 'Pet hair removal'
}
